module.exports = __webpack_public_path__ + "capacitor.5d63a2.svg";